import { render, staticRenderFns } from "./BranchRow.vue?vue&type=template&id=20ac8cc0&scoped=true"
import script from "./BranchRow.vue?vue&type=script&lang=ts"
export * from "./BranchRow.vue?vue&type=script&lang=ts"
import style0 from "./BranchRow.vue?vue&type=style&index=0&id=20ac8cc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac8cc0",
  null
  
)

export default component.exports